(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["text"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function () {
  const observerOptions = {
    root: null,
    rootMargin: "0px 0px -80px 0px", // Se activa 80px antes de entrar en pantalla
    threshold: 0.05 // Se activa en cuanto asoma el 5% de la imagen
  };

  const scrollAnimationObserver = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target); // Deja de vigilarlo tras animarse
      }
    });
  }, observerOptions);

  // Seleccionamos tanto los elementos con "fade-in-up" como las imágenes con "fade-in"
  const elementsToAnimate = document.querySelectorAll('.fade-in-up-element:not(.product-card *, [class*="product-card"] *), .fade-in-element');
  elementsToAnimate.forEach(element => scrollAnimationObserver.observe(element));
});
  } catch(e) { console.error(e); }
})();

})();
